import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription } from "@/components/ui/dialog";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";

export function ChangePasswordDialog() {
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password updated");
      setOpen(false); setCurrent(""); setNext("");
    } catch (e) {
      setErr(apiError(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          data-testid="open-change-password"
          className="rounded-full p-2 text-amber-100/70 transition-colors hover:bg-white/10 hover:text-amber-50"
          aria-label="Change password"
        >
          <KeyRound className="h-4 w-4" />
        </button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">Change password</DialogTitle>
          <DialogDescription>Set your own password for this account.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-sm font-medium">Current password</label>
            <input
              data-testid="current-password-input"
              type="password"
              required
              value={current}
              onChange={(e) => setCurrent(e.target.value)}
              className="mt-1 w-full rounded-xl border border-input bg-background px-4 py-2.5 outline-none focus:ring-2 focus:ring-ring"
              placeholder="Current password"
            />
          </div>
          <div>
            <label className="text-sm font-medium">New password</label>
            <input
              data-testid="new-password-input"
              type="password"
              required
              value={next}
              onChange={(e) => setNext(e.target.value)}
              className="mt-1 w-full rounded-xl border border-input bg-background px-4 py-2.5 outline-none focus:ring-2 focus:ring-ring"
              placeholder="At least 6 characters"
            />
          </div>
          {err && <p data-testid="change-password-error" className="text-sm text-destructive">{err}</p>}
          <button
            data-testid="submit-change-password"
            disabled={loading}
            className="flex w-full items-center justify-center gap-2 rounded-full bg-primary py-3 font-semibold text-primary-foreground transition-colors hover:bg-[#B82332] disabled:opacity-60"
          >
            {loading && <Loader2 className="h-4 w-4 animate-spin" />} Update password
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
